import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class EcConfigurationService {

  constructor(private http: HttpClient) { }

  saveConfigurationForm(
    baseUrl: string,
    formData: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=1e7w72`;
    const globalParams = globalService?.globalParams ?? globalService ?? {};
    const scenarioCode =
      filterParams?.scenarioCode ??
      filterParams?.scenario_code ??
      globalParams?.scenarioCode ??
      globalParams?.scenario_code ??
      rowData?.SCENARIO_CODE ??
      'RAF';
    const isIssueKeyEnabled =
      filterParams?.is_issue_key_enabled ??
      globalParams?.is_issue_key_enabled ??
      (scenarioCode === 'RAF' ? 'N' : 'Y');

    const jsonSettings = JSON.stringify({
      tax_year: String(filterParams?.tax_year ?? globalParams?.tax_year ?? rowData?.TAX_YEAR ?? '')
    });

    const params: any = _.merge({}, globalParams);
    params.json_data = JSON.stringify([formData]);
    params.jsonSettings = jsonSettings;
    params.is_issue_key_enabled = isIssueKeyEnabled;
    params.scenarioCode = scenarioCode;

    return this.postFormEncoded(url, params);
  }

  updateConfigurationForm(
    baseUrl: string,
    formData: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=je5ozq`;
    const globalParams = globalService?.globalParams ?? globalService ?? {};

    const jsonSettings = JSON.stringify({
      tax_year: String(filterParams?.tax_year ?? globalParams?.tax_year ?? rowData?.TAX_YEAR ?? '')
    });

    const params: any = _.merge({}, globalParams);
    params.json_data = JSON.stringify(formData);
    params.jsonSettings = jsonSettings;
    params.is_issue_key_enabled = 'N';

    return this.postFormEncoded(url, params);
  }

  private postFormEncoded(url: string, params: Record<string, any>): Observable<any> {
    const body = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        body.set(key, String(value));
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, body.toString(), { headers, withCredentials: true });
  }
}
